import "vuetify/styles"; // Global CSS has to be imported
import { createApp } from "vue";
import { createVuetify } from "vuetify";

import { store } from "./store/store";
import router from "./router/router";

import Vue3Tour from "vue3-tour";

import "vue3-tour/dist/vue3-tour.css";

import "@mdi/font/css/materialdesignicons.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import VuePaycard from "vue-paycard-portuguese";

import VueMobileDetection from "../node_modules/vue-mobile-detection";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "font-awesome-animation/css/font-awesome-animation.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import App from "./App.vue";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

library.add(fas);

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);
app.use(VueSweetalert2);
app.use(store);
app.use(router);
app.use(Vue3Tour);
app.use(vuetify);
app.use(VueMobileDetection);
app.use(VuePaycard);
app.component("faT", FontAwesomeIcon).mount("#app");
